import { useGLTF, useAnimations } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { ObjectLoader, LoopOnce } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import './common-DBpCdW70.esm.js';

const CheckMark = () => {
  const modelRef = useRef();
  const model = useGLTF(defineSrc('check-mark.glb'));
  const {
    animations,
    scene
  } = model;
  const lights = useLoader(ObjectLoader, defineSrc('check-mark-light.json'));
  const {
    mixer,
    clips
  } = useAnimations(animations, modelRef);
  useFrame(() => {
    model.materials['Standard'].map.offset.x += -25e-4;
    mixer.clipAction(clips[0]).play().setLoop(LoopOnce, 1);
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      ref: modelRef,
      scale: 1.4,
      object: scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { CheckMark as default };
//# sourceMappingURL=CheckMark-BQNmIm2B.esm.js.map
